import React from "react";

const CommonSpinner = () => {
  return (
    <div className="text-center spinner_loaderflex">
      {" "}
      <div className="spinner-border spinner_loader01" role="status">
        {" "}
      </div>{" "}
    </div>
  );
};

export default CommonSpinner;
